import React from "react";
import "./Base.css";

export const BaseButton = ({
  buttonClass = "",
  buttonText,
  buttonType,
  handleClick,
  isDisabled,
  isInverse,
  widthClass = "",
  isUnstyled = false,
  ariaPressed,
}) => {
  let buttonColorClass = isInverse
    ? "inverse-button"
    : "Green Background-LGreen";

  const defaultClasses = isUnstyled ? "" : `${buttonColorClass} p-1 bord-15`;

  return (
    <button
      className={`${defaultClasses} ${buttonClass} ${widthClass}`}
      disabled={isDisabled}
      onClick={handleClick}
      type={buttonType}
      aria-pressed={ariaPressed}
    >
      {buttonText}
    </button>
  );
};

export default BaseButton;
